import React from 'react';
import { useParams } from 'react-router-dom';
import CallCenter from '../../components/CallCenter';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Params = {
    resultCode: string;
    resultScore: string;
}

const PsychlngclCheckHappyResult: React.FC = () => {
    const {resultCode, resultScore} = useParams<Params>();
    const viewResult = (resultCode: string) => {
        switch(resultCode) {
            case "001" :
                return (
                    <>
                        <p className="result">매우 낮음</p> 
                    </>
                )
            case "002" :
                return (
                    <>
                        <p className="result">낮음</p>
                    </>
                )
            case "003" :
                return (
                    <>
                        <p className="result">평균</p>
                    </>
                )
            case "004" :
                return (
                    <>
                        <p className="result">높음</p>
                    </>
                )
            case "005" :
                return (
                    <>
                        <p className="result">매우 높음</p>
                    </>
                )
        }
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className='contents'>
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='행복 자가진단'
                        />
                        <div className='mobileface testing'>
                            <div className="resultWrap traumatic">
                                <h3 className="f18 black">외상 후 스트레스</h3>
                                <h4 className="f14 green mt30">외상 후 스트레스 결과</h4>
                                <div className="total type2">
                                    <div className="grade">
                                        <p><span>{resultScore}</span>점</p>
                                    </div>
                                    <div className="text">
                                        {
                                            resultCode? (
                                                viewResult(resultCode)
                                            ) : (
                                                viewResult("001")
                                            )
                                        }
                                    </div>
								</div>
                                <CallCenter />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckHappyResult;